"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBooksBoxPrintable;
const uuid_1 = require("uuid");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
function createBooksBoxPrintable(sku, userId, projectId, creationDate, template, printableId) {
  if (!template.woodenBox) {
    return (0, either_1.left)(new Error('Cannot find woodenBox definition on template'));
  }
  const design = template.woodenBox.design;
  const id = printableId || (0, uuid_1.v4)();
  const createBoxPrintable = {
    id,
    parentId: projectId,
    createdAt: creationDate,
    lastModifiedAt: creationDate,
    version: (0, Printable_1.generatePrintableVersion)(creationDate, id),
    designId: design.id,
    surface: template.woodenBox.surface,
    lastModifiedBy: userId,
    lastModifiedByAdmin: false,
    isCompositeDesign: false,
    layers: template.woodenBox.layers
  };
  return (0, either_1.right)(createBoxPrintable);
}